import { getFormattedDateTime } from "@/utils";
import type { TransactionReport } from "@/api/giftcard.api";

// Helper function to format coupon type
export const getCouponTypeLabel = (type: number): string => {
  return type === 1 ? "Flat Discount" : "Percentage";
};

// Helper function to format rule type
export const getRuleTypeLabel = (type: number): string => {
  return type === 1 ? "Single Use" : "Multiple Use";
};

// Helper function to format invoice value range
export const formatInvoiceValue = (from: number, to: number): string => {
  return `${from} - ${to}`;
};

// Helper function to format date
export const formatDate = (dateString: string): string => {
  return getFormattedDateTime(dateString) || dateString || "";
};

export function formatTxnDateTime(dateString?: string | null) {
  if (!dateString) return "";
  return getFormattedDateTime(dateString) || dateString;
}

export function formatReportAmount(value?: number | null) {
  if (value === null || value === undefined) return "";
  const amount = Number(value);
  if (Number.isNaN(amount)) return "";
  return amount.toLocaleString("en-IN");
}

export function displayReportText(value?: string | null) {
  const trimmed = value?.trim();
  return trimmed ? trimmed : "";
}

export function mapTransactionReportList(
  list: TransactionReport[] | undefined
): TransactionReport[] {
  if (!Array.isArray(list)) return [];

  return list.map((item) => ({
    mobileNo: item.mobileNo ?? "",
    invoiceNo: item.invoiceNo ?? "",
    invoiceAmount: Number(item.invoiceAmount ?? 0),
    transactionType: item.transactionType ?? "",
    couponCode: item.couponCode ?? null,
    txnDate: item.txnDate ?? "",
    redeemAmount: Number(item.redeemAmount ?? 0),
  }));
}

// Helper function to format date for API without timezone conversion
export const formatDateForAPI = (date: Date): string => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}T00:00:00`;
};
